export const CUSTOM_SIGN_UP = 'PureCustomSignUp';
export const ENTER_PASSWORD_PAGE = 'PureEnterPasswordPage';
export const CREATE_USER_ACCOUNT = 'PureCreateUserAccount';

export const inlineErrors = {
  sso: 'SIGNUP.SSO_ERROR',
  expired: 'SIGNUP.EXPIRED_ERROR',
  invited: 'SIGNUP.INVITED_ERROR',
  notPermitted: 'SIGNUP.EMAIL_NOT_PERMITTED',
};
